module.exports = __webpack_public_path__ + "assets/img/1_928.26a60171.jpg";